import React, { useState, useEffect } from 'react'

import Fade from '@mui/material/Fade'
import Box from '@mui/material/Box'
import Table from '@mui/material/Table';
import Grid from '@mui/material/Grid';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

import StandardsHead from './standards-head'
import StandardsBody from './standards-body'
import StandardsChart from './standards-chart'
import StandardsAssessment from './standards-assessment'
import Loading from './components/loading';
import Legend from './components/legend';
import useStyles from './styles'

export default function StandardsResults ({context}) {

  const classes = useStyles()

  const {standardsContext,  translate} = context

  const {assessmentStandards} = standardsContext 

  const standardsFound = assessmentStandards.items.length > 0;

  const [loading, setLoading] = useState(true);

  const assessmentLoaded = !context.quizSearch['assessment-to-review'];

  useEffect(() => {
	  if(assessmentStandards.loaded){
		setTimeout(() => {
			setLoading(false);
		  }, 3000)
	  }
  })

  return (
		<Box className={classes.root}>
			<Fade in={assessmentLoaded}>
				<Box className={classes.preview}>
					<Box className={classes.viewHeader} >
						<StandardsAssessment context={context} />
					</Box>
					<Box className={classes.section} >
						<Grid container spacing={2}>
							<Grid item xs={12}>
								{translate('standards-domain')}
							</Grid>
						</Grid>
						{ !loading && (
							<Legend context={context} />
						)}
					</Box>		
					{!loading && standardsFound && assessmentStandards.items.map((stds, index) => {
						var indicatorCode = [];
						return (
								<Box className={classes.viewContent} key={index}>
									<Box className={classes.viewHeaderTable}>
										<StandardsChart context={context} standard={stds} standardIndex={index}/>	
									</Box>
									<Table className={classes.table}>
										<StandardsHead context={context}/>
										<StandardsBody context={context} stds={stds} indicatorCode={indicatorCode}/>
									</Table>
								</Box>		
						)
						}) 
					}
					{!loading && !standardsFound && (
							<Box className={classes.viewContent}>
								<Stack sx={{ width: '100%' }} spacing={2}>
									<Alert severity="info">{translate('no-standards-specified')}</Alert>
								</Stack>
							</Box>	
					)}	
					{loading && (
						<Loading />
					)}					
				</Box>
	  		</Fade>
		</Box>
    )
}
